import { useDocumentTitle } from '@mantine/hooks';
import { FormErrors } from '@mantine/form';
import { useState } from 'react';
import { CreateUser } from '../Logic/ST/CreateUser.ts';
import {
    redirectToUrlOrLegacyHome,
    redirectToUsuarioCreado,
} from '../Logic/Rutas.ts';

export interface Values {
    email: string;
    password: string;
}

export interface MigracionHookProps {
    cid?: string;
    uid: string;
    super_admin?: string;
    returnTo?: string;
}

export interface MigracionHookReturn {
    loading: boolean;
    onSubmit: (values: Values) => void;
    errorMessage?: string;
    formErrors: FormErrors;
}

export function MigracionHook({
    cid,
    super_admin,
    uid,
    returnTo,
}: MigracionHookProps): MigracionHookReturn {
    useDocumentTitle('Confirmar - Luker.io');
    const [errorMessage, setErrorMessage] = useState<string>();
    const [formErrors, setFormErrors] = useState<FormErrors>({});
    const [loading, setLoading] = useState<boolean>(false);

    return {
        errorMessage,
        formErrors,
        loading,
        onSubmit: async (values) => {
            setLoading(true);
            setErrorMessage('');
            setFormErrors({});
            try {
                const resp = await CreateUser({
                    email: values.email,
                    password: values.password,
                    cid,
                    uid,
                    is_admin: super_admin === 'true',
                });

                switch (resp.status) {
                    case 'ok': {
                        if (returnTo) {
                            //OJO! confiamos que desde el back se pase una url que sea un "migrated"
                            redirectToUrlOrLegacyHome(returnTo);
                        } else {
                            redirectToUsuarioCreado(values.email);
                        }
                        return;
                    }
                    case 'error': {
                        setLoading(false);
                        setFormErrors(resp.formErrors);
                        break;
                    }
                    default: {
                        setLoading(false);
                        setErrorMessage('Ha ocurrido un error');
                        break;
                    }
                }
            } catch (error: unknown) {
                console.error(error);
                setLoading(false);
                // if (err.isSuperTokensGeneralError === true) {
                //     // this may be a custom error message sent from the API by you.
                // }
                if (error instanceof Error) {
                    setErrorMessage(`Ha ocurrido un error: ${error.message}`);
                } else {
                    setErrorMessage(`Ha ocurrido un error`);
                }
            }
        },
    };
}
